export const toDateFormat = value => {
  let dateFormat =
    ('0' + value.getDate()).slice(-2) + "/" +
    ('0' + (value.getMonth() + 1)).slice(-2) + "/" +
    value.getFullYear().toString().slice(-2)

  return dateFormat
}

export const onlyNumber = value => value.replace(/[^\d]/g, '')

export const onlyString = value => value.replace(/[0-9]/g, '')

export const phoneMask = (value) => value.replace(/[0-9]/g, '*')

export const emailMask = (value) => value.replace(/[a-z]/g, '*').replace(/[A-Z]/g, '*').replace(/[0-9]/g, '*')

export const currency = (value, decimals=true) => {
  if(decimals) {
    value=value.replace(/\D/g,"")
    value=value.replace(/(\d{2})$/,",$1")
    value=value.replace(/(\d+)(\d{3},\d{2})$/g,"$1.$2")
  }

  let qtdLoop = (value.length-3)/3
  let count = 0
  while (qtdLoop > count) {
    count++
    value=value.replace(/(\d+)(\d{3}.*)/,"$1.$2")
  }
  value = value.replace(/^(0)(\d)/g,"$2")

  return value
}

export const capitalize = value => {
  return value
    .toLowerCase()
    .replace(/(^|\s)\S(?=[a-zà-ÿ]{2})/g, function(letter) {
      return letter.toUpperCase()
    });
}

export const cpf = value => {
  const cpfOnlyNumber = onlyNumber(value)

  if (!value) {
    return value
  }
  if (value.length <= 3) {
    return `${cpfOnlyNumber}`
  }
  if (value.length <= 7) {
    return `${cpfOnlyNumber.slice(0, 3)}.${cpfOnlyNumber.slice(3, 6)}`
  }
  if (value.length <= 11) {
    return `${cpfOnlyNumber.slice(0, 3)}.${cpfOnlyNumber.slice(3, 6)}.${cpfOnlyNumber.slice(6, 9)}`
  }
  if (value.length <= 14) {
    return `${cpfOnlyNumber.slice(0, 3)}.${cpfOnlyNumber.slice(3, 6)}.${cpfOnlyNumber.slice(6, 9)}-${cpfOnlyNumber.slice(9, 11)}`
  }
}

export const phone = value => {
  const phoneOnlyNumber = onlyNumber(value)

  if (!value) {
    return value
  }
  if (value.length <= 2) {
    return `(${phoneOnlyNumber.slice(0, 2)}`
  }
  if (value.length <= 3) {
    return `(${phoneOnlyNumber.slice(0, 2)}`
  }
  if (value.length <= 8) {
    return `(${phoneOnlyNumber.slice(0, 2)})${phoneOnlyNumber.slice(2, 6)}`
  }
  if (value.length <= 13) {
    return `(${phoneOnlyNumber.slice(0, 2)})${phoneOnlyNumber.slice(2, 6)}-${phoneOnlyNumber.slice(6, 11)}`
  }
  if (value.length <= 14) {
    return `(${phoneOnlyNumber.slice(0, 2)})${phoneOnlyNumber.slice(2, 7)}-${phoneOnlyNumber.slice(7, 11)}`
  }
}

export const oabNumber = value => {
  const regex = /([0-9]|[A-Z]|[a-z]){0,6}/g
  let match = value.match(regex)
  if (match !== null) {
    return match[0].toUpperCase()
  }
}

export const cnpj = value => {
  const cnpjOnlyNumber = onlyNumber(value)

  if (!value) {
    return value
  }
  if (value.length <= 2) {
    return `${cnpjOnlyNumber.slice(0, 2)}`
  }
  if (value.length <= 6) {
    return `${cnpjOnlyNumber.slice(0, 2)}.${cnpjOnlyNumber.slice(2, 5)}`
  }
  if (value.length <= 10) {
    return `${cnpjOnlyNumber.slice(0, 2)}.${cnpjOnlyNumber.slice(2, 5)}.${cnpjOnlyNumber.slice(5, 8)}`
  }
  if (value.length <= 15) {
    return `${cnpjOnlyNumber.slice(0, 2)}.${cnpjOnlyNumber.slice(2, 5)}.${cnpjOnlyNumber.slice(5, 8)}/${cnpjOnlyNumber.slice(8, 12)}`
  }
  if (value.length <= 18) {
    return `${cnpjOnlyNumber.slice(0, 2)}.${cnpjOnlyNumber.slice(2, 5)}.${cnpjOnlyNumber.slice(5, 8)}/${cnpjOnlyNumber.slice(8, 12)}-${cnpjOnlyNumber.slice(12, 14)}`
  }
}

export const uf = value => {
  if (value.length <= 2) {
    return onlyString(value).toUpperCase()
  }
  else{
    return value.slice(0, 2).toUpperCase()
  }
}

export const lawsuitNumber = value => {
  const lawsuitNumberOnlyNumber = onlyNumber(value)

  if (!value) {
    return value
  }
  if (value.length <= 7) {
    return `${lawsuitNumberOnlyNumber.slice(0, 7)}`
  }
  if (value.length <= 10) {
    return `${lawsuitNumberOnlyNumber.slice(0, 7)}-${lawsuitNumberOnlyNumber.slice(7, 9)}`
  }
  if (value.length <= 15) {
    return `${lawsuitNumberOnlyNumber.slice(0, 7)}-${lawsuitNumberOnlyNumber.slice(7, 9)}.${lawsuitNumberOnlyNumber.slice(9, 13)}`
  }
  if (value.length <= 17) {
    return `${lawsuitNumberOnlyNumber.slice(0, 7)}-${lawsuitNumberOnlyNumber.slice(7, 9)}.${lawsuitNumberOnlyNumber.slice(9, 13)}.${lawsuitNumberOnlyNumber.slice(13, 14)}`
  }
  if (value.length <= 20) {
    return `${lawsuitNumberOnlyNumber.slice(0, 7)}-${lawsuitNumberOnlyNumber.slice(7, 9)}.${lawsuitNumberOnlyNumber.slice(9, 13)}.${lawsuitNumberOnlyNumber.slice(13, 14)}.${lawsuitNumberOnlyNumber.slice(14, 16)}`
  }

  return `${lawsuitNumberOnlyNumber.slice(0, 7)}-${lawsuitNumberOnlyNumber.slice(7, 9)}.${lawsuitNumberOnlyNumber.slice(9, 13)}.${lawsuitNumberOnlyNumber.slice(13, 14)}.${lawsuitNumberOnlyNumber.slice(14, 16)}.${lawsuitNumberOnlyNumber.slice(16, 20)}`
}


export const deadlineDate = (date) => {
  let newDate = date.setTime(date.getTime() + (3 * 60 * 60 * 1000))
  return newDate
}